import styled from '@emotion/styled'

export const Subtitle3 = styled.p(({ theme }) => ({
  fontFamily: theme.typography.family.default,
  fontSize: '0.6875rem',
  lineHeight: 2.18,
  fontWeight: 500,
  letterSpacing: 1,
  margin: 0,
  padding: 0,
}))
